import { render, staticRenderFns } from "./AccountTransaction.vue?vue&type=template&id=20323a6e&scoped=true&"
import script from "./AccountTransaction.vue?vue&type=script&lang=js&"
export * from "./AccountTransaction.vue?vue&type=script&lang=js&"
import style0 from "./AccountTransaction.vue?vue&type=style&index=0&id=20323a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20323a6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
